import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
	Box,
	Button,
	Container,
	Typography,
	Divider,
	TextField,
	Autocomplete,
	Chip,
	InputAdornment,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	IconButton,
} from "@mui/material";

import { useAuth } from "../../helpers/AuthProvider";
import queryGraphql from "../../helpers/ApiInterface";
import { ExpandMore } from "@mui/icons-material";
import MainDrawer from "../MainDrawer";
import ClusterRequestsTable from "./ClusterRequestsTable";
import MiniBot from "../MiniBot";
interface SearchOptions {
	chipLabel: string;
	dropdownLabel: string;
	category: string;
	groupBy: string;
}

let searchOptions: SearchOptions[] = [];
const ClusterRequestsPage: React.FC = () => {
	const [clusters, setClusters] = useState([]);
	const { user } = useAuth();
	const navigate = useNavigate();
	const [searchQuery, setSearchQuery] = useState<SearchOptions[]>([]);
	const [updates, setUpdates] =  useState<any>([]);


	const isClusterOwner = user.roles.some((e: string) => ["cluster_owner"].includes(e)) || false;

	React.useEffect(() =>{
		const fetchData = async () => {
			try {
				const data = await queryGraphql(`
                        query Query {
						resourceStatuses {
							id
							currentStatus
							resourceId
						}
						}
					`);
				if(data.resourceStatuses){
					setUpdates(data.resourceStatuses);
					
				}
				}
				catch(e){
			console.log(e);
				}
	}
	fetchData();
	},[]);	

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const data = await queryGraphql(`
                        query{
                        clusters {
						id,
                        clusterName,
                        actionedAt,
                        clusterApprover{
                        id,
                        email,
                        googleProfilePicture,
						name
                        },
                        clusterOwner{
						id,
						email,
						googleProfilePicture,
						name
						},
						reasonForRejection,
						status,
                        createdAt,
                        }
                        }
					`);

				let clustersArr = data.clusters.map((e: any) => {
					return {
						...e,
						clusterOwnerAvatar: e?.clusterOwner?.googleProfilePicture,
						clusterOwner: e?.clusterOwner?.name,
						clusterApproverAvatar: e?.clusterApprover?.googleProfilePicture,
						clusterApprover: e?.clusterApprover?.name,
						createdAt: new Date(Number(e.createdAt)).toISOString(),
						actionedAt: new Date(Number(e.actionedAt)).toISOString(),
					};
				});
				setClusters(clustersArr);
				searchOptions = clustersArr
					.map((e: any) => {
						return [
							{
								category: "clusterName",
								groupBy: "CLUSTER NAME",
								chipLabel: `Cluster Name: ${e.clusterName}`,
								dropdownLabel: e.clusterName,
							},

							{
								category: "clusterOwner",
								groupBy: "OWNER",
								chipLabel: `Owner: ${e.clusterOwner}`,
								dropdownLabel: e.clusterOwner,
							},
							{
								category: "clusterApprover",
								groupBy: "ACTIONED BY",
								chipLabel: `Actioned By: ${e.clusterApprover}`,
								dropdownLabel: e.clusterApprover,
							},
						];
					})
					.flat();

				searchOptions = searchOptions.filter(
					(obj, index, self) =>
						index ===
						self.findIndex(
							(t) => t.category === obj.category && t.dropdownLabel === obj.dropdownLabel
						)
				);
				searchOptions.sort((a, b) => {
					if (a.groupBy > b.groupBy) return 1;
					if (a.groupBy < b.groupBy) return -1;
					if (a.dropdownLabel > b.dropdownLabel) return 1;
					if (a.dropdownLabel < b.dropdownLabel) return -1;
					return 0;
				});

				// setUsers(result.data.users);
				// setLoading(false);
			} catch (error) {
				// setError(error.message);
				// setLoading(false);
				console.log(error);
			}
		};

		fetchData();
	}, []);

	const filteredClusters =
		searchQuery.length == 0
			? clusters
			: clusters.filter(
					(cluster: any) =>
						(searchQuery.filter((e) => e.category == "clusterName").length > 0
							? searchQuery
									.filter((e) => e.category == "clusterName")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(cluster.clusterName?.toLowerCase())
							: true) &&
						(searchQuery.filter((e) => e.category == "clusterOwner").length > 0
							? searchQuery
									.filter((e) => e.category == "clusterOwner")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(cluster.clusterOwner?.toLowerCase())
							: true) &&
						(searchQuery.filter((e) => e.category == "clusterApprover").length > 0
							? searchQuery
									.filter((e) => e.category == "clusterApprover")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(cluster.clusterApprover?.toLowerCase())
							: true)
			  );

	const filteredActiveClusters = filteredClusters.filter(
		(cluster: any) => cluster.status === "active"
	);
	const filteredPendingClusters = filteredClusters.filter(
		(cluster: any) => cluster.status === "pending"
	);
	const filteredRejectedClusters = filteredClusters.filter(
		(cluster: any) => cluster.status === "rejected"
	);

	return (
		<Box sx={{ display: "flex" }}>
			<MainDrawer index={"requests-cluster"} />
			<MiniBot/>
			<Box
				component="main"
				// display="inline-block"
				sx={{
					flex: 1,
					bgcolor: "#fafafa",

					minHeight: window.innerHeight,
				}}
			>
				<Container maxWidth={false} disableGutters>
					<Box bgcolor="#FFFFFF" p={2} mb="18px">
						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								marginY: 1,
								marginLeft: 2,
							}}
						>
							
							<Typography fontSize="22px" gutterBottom fontFamily="Gilroy-Bold">
								Requests
							</Typography>
							<IconButton
																	  aria-label="Help" 
																	  onClick={()=> window.open(`${process.env.REACT_APP_HOST_DOMAIN}/docs` , "_blank")}
																	  sx={{
																		padding: 0, 
																		border: 'none',  
																		mr:2,
																		'&:hover': {
																		  
																		  backgroundColor: 'action.hover', 
																		},
																		
																	  }}
																	>
																	  <Box
																		component="img"
																		src="/assets/Help.svg" 
																		alt="" 
																		sx={{
																		  width: 40,  
																		  height: 40,
																		  display: 'block', 
																		}}
																	  />
																	</IconButton>
						</Box>
						<Divider sx={{ marginY: 1 }} />
						<Box
							sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mx: 2 }}
						>
							<Box>
								<Typography
									fontFamily="Gilroy-SemiBold"
									fontSize="16px"
								>{`CLUSTERS (${clusters.length})`}</Typography>
								<Typography
									fontFamily="Gilroy-Regular"
									fontSize="14px"
								>{`View all the requests raised by the cluster owners`}</Typography>
							</Box>
							<Autocomplete
								multiple
								options={searchOptions}
								filterSelectedOptions
								getOptionLabel={(option) => option.dropdownLabel}
								defaultValue={[]}
								groupBy={(option) => option.groupBy}
								renderTags={(tagValue, getTagProps) => {
									return tagValue.map((option, index) => (
										<Chip {...getTagProps({ index })} size="small" label={option.chipLabel} />
									));
								}}
								onChange={(e, newVal, reason) => {
									setSearchQuery(newVal);
								}}
								renderInput={(params) => (
									<TextField
										{...params}
										variant="filled"
										placeholder="Search by cluster name, environment, owner etc"
										fullWidth
										size="small"
										hiddenLabel
										InputProps={{
											...params.InputProps,
											startAdornment: (
												<>
													<InputAdornment position="start">
														<img
															src="/assets/search-normal.svg"
															alt="Filter Icon"
															style={{ width: "16px", paddingLeft: "4px" }}
														/>
													</InputAdornment>
													{params.InputProps.startAdornment}
												</>
											),
											disableUnderline: true,
											style: {
												backgroundColor: "#f4f4f4",
												minHeight: "45px",
												width: "500px",
												borderRadius: "8px",
												fontFamily: "Gilroy-Regular",
												fontSize: "14px",
											},
										}}
									/>
								)}
							/>
						</Box>
					</Box>
					<Box m={2}>
						<Accordion
							defaultExpanded={filteredPendingClusters.length > 0 ? true : false}
							elevation={0}
							sx={{
								borderRadius: "8px",
								mb: "16px",
								"&:before": {
									display: "none",
								},
								bgcolor: "#fafafa",
							}}
							disabled={filteredPendingClusters.length == 0}
						>
							<AccordionSummary expandIcon={<ExpandMore />}>
								<Box sx={{ display: "flex", alignItems: "center" }}>
									<img
										src="/assets/clock.svg"
										alt="Pending Icon"
										style={{ width: "20px", marginRight: "8px" }}
									/>
									<Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
										Pending Clusters ({filteredPendingClusters.length})
									</Typography>
								</Box>
							</AccordionSummary>
							<AccordionDetails>
								{filteredPendingClusters.length > 0 && (
									<ClusterRequestsTable clusters={filteredPendingClusters} type="pending" resourceStatuses={updates} />
								)}
							</AccordionDetails>
						</Accordion>
						<Accordion
						defaultExpanded={true}
							elevation={0}
							sx={{
								borderRadius: "8px",
								mb: "16px",
								"&:before": {
									display: "none",
								},
								bgcolor: "#fafafa",
							}}
							disabled={filteredActiveClusters.length == 0}
						>
							<AccordionSummary expandIcon={<ExpandMore />}>
								<Box sx={{ display: "flex", alignItems: "center" }}>
									<img
										src="/assets/tickcircle.svg"
										alt="Active Icon"
										style={{ width: "20px", marginRight: "8px" }}
									/>
									<Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
										Active Clusters ({filteredActiveClusters.length})
									</Typography>
								</Box>
							</AccordionSummary>
							<AccordionDetails>
								{filteredActiveClusters.length > 0 && (
									<>
										<ClusterRequestsTable clusters={filteredActiveClusters} type="active" resourceStatuses={updates}/>
									</>
								)}
							</AccordionDetails>
						</Accordion>

						<Accordion
							elevation={0}
							sx={{
								borderRadius: "8px",
								"&:before": {
									display: "none",
								},
								bgcolor: "#fafafa",
							}}
							disabled={filteredRejectedClusters.length == 0}
						>
							<AccordionSummary expandIcon={<ExpandMore />}>
								<Box sx={{ display: "flex", alignItems: "center" }}>
									<img
										src="/assets/reject.svg"
										alt="Rejected Icon"
										style={{ width: "20px", marginRight: "8px" }}
									/>
									<Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
										Rejected Clusters ({filteredRejectedClusters.length})
									</Typography>
								</Box>
							</AccordionSummary>
							<AccordionDetails>
								{filteredRejectedClusters.length > 0 && (
									<>
										<ClusterRequestsTable clusters={filteredRejectedClusters} type="rejected" resourceStatuses={updates} />
									</>
								)}
							</AccordionDetails>
						</Accordion>
					</Box>
				</Container>
			</Box>
		</Box>
	);
};

export default ClusterRequestsPage;
